import script from "./Cookie.vue?vue&type=script&setup=true&lang=js"
export * from "./Cookie.vue?vue&type=script&setup=true&lang=js"

import "./Cookie.vue?vue&type=style&index=0&id=045f169a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045f169a"]])

export default __exports__